var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsotipoDarkSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 171,
    viewBox: "0 0 136 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5183 68.2589C8.18598 68.2589 0.585938 75.8591 0.585938 85.1914C0.585938 94.5237 8.18598 102.124 17.5183 102.124H118.801C128.133 102.124 135.733 94.5237 135.733 85.1914C135.733 75.8591 128.133 68.2589 118.801 68.2589H17.5183Z",
    fill: "#7A59E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.367 137.05C63.2951 137.05 59.3312 139.204 55.6794 142.84C52.0432 146.476 48.1262 148.395 43.1323 148.395C38.1384 148.395 34.4242 146.647 30.4603 142.684C26.4964 138.72 22.907 137.05 17.9287 137.05C8.62757 137.05 1.10547 144.588 1.10547 153.873C1.10547 163.159 8.64317 170.696 17.9287 170.696C22.9538 170.696 26.7304 168.792 30.5227 165C34.2993 161.223 38.1072 159.335 43.1323 159.335C48.1574 159.335 51.8716 161.114 55.8667 165.109C59.8618 169.104 63.4044 170.696 68.367 170.696C77.6682 170.696 85.1902 163.159 85.1902 153.873C85.1902 144.588 77.6526 137.05 68.367 137.05Z",
    fill: "#7A59E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3816 0.732178C8.01804 0.732178 0.417969 8.34786 0.417969 17.6958C0.417969 27.0437 8.03365 34.6594 17.3816 34.6594H68.8967C78.2602 34.6594 85.8604 27.0437 85.8604 17.6958C85.8604 8.34786 78.2446 0.732178 68.8967 0.732178H17.3816Z",
    fill: "#7A59E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.761 34.4878C128.052 34.4878 135.584 26.9558 135.584 17.6646C135.584 8.37338 128.052 0.841339 118.761 0.841339C109.469 0.841339 101.938 8.37338 101.938 17.6646C101.938 26.9558 109.469 34.4878 118.761 34.4878Z",
    fill: "#7A59E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.395 137.253C105.008 137.253 102.246 140.015 102.246 143.401V164.345C102.246 167.731 105.008 170.493 108.395 170.493H129.447C132.834 170.493 135.596 167.731 135.596 164.345V143.401C135.596 140.015 132.834 137.253 129.447 137.253H108.395Z",
    fill: "#7A59E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipoDarkSecondary);
export default __webpack_public_path__ + "static/media/isotipo_dark_secondary.09a2a0f4d5fa35d5b2da81238d0a6351.svg";
export { ForwardRef as ReactComponent };